export default {
      id: "dns-error-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.svg#dns-error",
      toString: function () {
        return this.url;
      }
    }